import React from 'react'
import logo from '../../assets/images/logo.png'

export default function Section3() {
  return (
    <div className='w-full border-[1px] border-[#ccc] flex items-center justify-center p-[20px]'>
        <a href='https://myu.vn/'><img src={logo} alt='logo' className='w-[90px]' /></a>
        <p className='ml-[10px]'>Copyright © 2024 by myU. All rights reserved.</p>
    </div> 
  )
}
